import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import Sidebar from "../../../../common/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../constants";
import {
  getSingleQuickTale,
  getSingleUser,
  getSpecificUserQuickTales,
} from "../../../OrganizationQuickTales/hooks/QuickTalesHooks";

import {
  getAlbumbyId,
  // getQuicktalesSharedWithUser,
  getSpecificUserAlbumShares,
  getSpecificUserQuicktaleShares,
  quickTalesSearch,
} from "../../hooks/AlbumsHooks";
import { useQuickTalesContext } from "../../../../providers/OrganizationAdmin/QuickTalesProvider";
import { useAlbumsContext } from "../../../../providers/OrganizationAdmin/AlbumProvider";

import { updateAlbum } from "../../hooks/AlbumsHooks";
import CommonTable from "../../../../common/CommonTable";
import TableSearchBar from "../../../../common/TableSearchBar";
import QuickTalesTableRow from "../../../../common/QuickTalesTableRow";

const AddQuickTalesToAlbumContainer = () => {
  const { loading, setLoading, approvedQuickTales, handleGetAllQuickTales } =
    useQuickTalesContext();
  const {} = useAlbumsContext();

  const location = useLocation();
  const navigate = useNavigate();

  const [albumDetails, setAlbumDetails] = useState(location.state.albumDetails);
  const [selected, setSelected] = useState([]);
  const [quictalesInOrg, setQuictalesInOrg] = useState([]);
  const [allQuickTales, setAllQuickTales] = useState([]);
  const idsToRemove = albumDetails.quicktales; // IDs to remove from the quicktales

  // useEffect(() => {
  //   if (
  //     location?.state?.albumDetails?.userData == null ||
  //     location?.state?.albumDetails?.userData == {}
  //   ) {
  //     setQuictalesInOrg(approvedQuickTales);
  //     setAllQuickTales(approvedQuickTales);
  //   } else {
  //     handleGetUserAlbums();
  //   }
  // }, []);

  useEffect(() => {
    setAlbumDetails(location.state.albumDetails);
    if (
      !location?.state?.albumDetails?.userData ||
      Object.keys(location?.state?.albumDetails?.userData).length === 0
    ) {
      handleGetAllQuickTales();
    }
  }, [location.state.albumDetails]);

  useEffect(() => {
    if (
      !location?.state?.albumDetails?.userData ||
      Object.keys(location?.state?.albumDetails?.userData).length === 0
    ) {
      setQuictalesInOrg(approvedQuickTales);
      setAllQuickTales(approvedQuickTales);
    }
  }, [approvedQuickTales]);

  useEffect(() => {
    if (
      location?.state?.albumDetails?.userData != null ||
      location?.state?.albumDetails?.userData != {}
    ) {
      handleGetUserAlbums();
    }
  }, []);

  const handleGetUserAlbums = async () => {
    try {
      const temp = [];
      const userId = location?.state?.albumDetails?.user;

      // Fetch the shared albums, user quick tales, and shared quicktales in parallel
      const [docsSnap, userQTsdocsSnap, sharedQTsdocsSnap] = await Promise.all([
        getSpecificUserAlbumShares(userId),
        getSpecificUserQuickTales(userId),
        getSpecificUserQuicktaleShares(userId),
      ]);

      // Convert QuerySnapshot to array of documents if necessary
      const docsArray = docsSnap.docs || docsSnap;

      // Helper function to process quick tales
      const processQuickTale = async (qtId) => {
        try {
          const userQTsdocsSnap = await getSingleQuickTale(qtId);
          const [userTemp, narratorTemp] = await Promise.all([
            getSingleUser(userQTsdocsSnap.data().createdBy),
            getSingleUser(userQTsdocsSnap.data().narrator),
          ]);

          return {
            id: userQTsdocsSnap.id,
            ...userQTsdocsSnap.data(),
            photoUrl:
              userQTsdocsSnap?.data().imageUrls?.[0] ||
              userQTsdocsSnap?.data().photoUrl ||
              "",
            createdByData: userTemp?.data() || null,
            narratorData: narratorTemp?.data() || null,
          };
        } catch (err) {
          console.error(`Error processing quick tale ID: ${qtId}`, err.message);
          return null; // Return null in case of an error to be filtered out later
        }
      };

      // Process shared albums and their quick tales
      const albumPromises = docsArray.map(async (item) => {
        try {
          const albumDocSnap = await getAlbumbyId(item.data().album);
          const qtsIdsTemp = albumDocSnap.data().quicktales || [];

          // Fetch all quick tales related to this album
          const quickTales = await Promise.all(
            qtsIdsTemp.map(async (qtId) => await processQuickTale(qtId))
          );

          return quickTales.filter(Boolean); // Filter out any null values
        } catch (err) {
          console.error(
            `Error processing album: ${item.data().album}`,
            err.message
          );
          return []; // Return empty array in case of an error
        }
      });

      const albumsData = (await Promise.all(albumPromises)).flat();

      // Process user quick tales
      const userQTsArray = userQTsdocsSnap.docs || userQTsdocsSnap;
      const userQuickTales = userQTsArray.map((item) => ({
        id: item.id,
        ...item.data(),
      }));

      // Process shared quick tales
      const sharedQTsArray = sharedQTsdocsSnap.docs || sharedQTsdocsSnap;
      const sharedQuickTales = await Promise.all(
        sharedQTsArray.map((item) => processQuickTale(item.data().quicktale))
      );

      // Combine all quick tales without duplicates
      const uniqueQuickTales = new Map();

      [
        ...albumsData,
        ...userQuickTales,
        ...sharedQuickTales.filter(Boolean),
      ].forEach((qt) => {
        if (!uniqueQuickTales.has(qt.id)) {
          uniqueQuickTales.set(qt.id, qt);
        }
      });

      const allQuickTalesTemp = Array.from(uniqueQuickTales.values());

      const filteredQuicktales = allQuickTalesTemp.filter(
        (quicktale) => !idsToRemove.includes(quicktale.id)
      );

      setQuictalesInOrg(filteredQuicktales);
      setAllQuickTales(filteredQuicktales);
      console.log("qt::", filteredQuicktales);

      return filteredQuicktales; // Return the data if needed elsewhere
    } catch (error) {
      console.error("Error getting user albums:", error.message);
      throw error; // Optionally rethrow to handle it in the calling function
    }
  };

  // const handleGetUserAlbums = async () => {
  //   try {
  //     const temp = [];
  //     const userId = location?.state?.albumDetails?.user;

  //     // Fetch user quicktales
  //     const userQTsdocsSnap = await getSpecificUserQuickTales(userId);
  //     const userQTsArray = userQTsdocsSnap.docs
  //       ? userQTsdocsSnap.docs
  //       : userQTsdocsSnap;

  //     // Process user quicktales
  //     userQTsArray.forEach((item) => {
  //       temp.push({ id: item.id, ...item.data() });
  //     });

  //     // Fetch shared quicktales
  //     const sharedQTsdocsSnap = await getQuicktalesSharedWithUser(userId);
  //     const sharedQTsArray = sharedQTsdocsSnap.docs
  //       ? sharedQTsdocsSnap.docs
  //       : sharedQTsdocsSnap;

  //     const sharedQtPromises = sharedQTsArray.map(async (item) => {
  //       const quickTaleId = item.data().quicktale;
  //       const userQTsdocsSnap = await getSingleQuickTale(quickTaleId);
  //       const [userTemp, narratorTemp] = await Promise.all([
  //         getSingleUser(userQTsdocsSnap.data().createdBy),
  //         getSingleUser(userQTsdocsSnap.data().narrator),
  //       ]);

  //       return {
  //         id: userQTsdocsSnap.id,
  //         ...userQTsdocsSnap.data(),
  //         photoUrl:
  //           userQTsdocsSnap?.data().imageUrls?.[0] ??
  //           userQTsdocsSnap?.data().photoUrl ??
  //           "",
  //         createdByData: userTemp?.data() ? userTemp.data() : null,
  //         narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //       };
  //     });

  //     const sharedQTsData = await Promise.all(sharedQtPromises);

  //     // Fetch shared albums
  //     const docsSnap = await getSpecificUserAlbumShares(userId);
  //     const docsArray = docsSnap.docs ? docsSnap.docs : docsSnap;

  //     // Process shared albums
  //     const albumPromises = docsArray.map(async (item) => {
  //       const albumDocSnap = await getAlbumbyId(item.data().album);
  //       const qtsIdsTemp = albumDocSnap.data().quicktales;

  //       const qtPromises = qtsIdsTemp.map(async (qt) => {
  //         const userQTsdocsSnap = await getSingleQuickTale(qt);
  //         const [userTemp, narratorTemp] = await Promise.all([
  //           getSingleUser(userQTsdocsSnap.data().createdBy),
  //           getSingleUser(userQTsdocsSnap.data().narrator),
  //         ]);

  //         return {
  //           id: userQTsdocsSnap.id,
  //           ...userQTsdocsSnap.data(),
  //           photoUrl:
  //             userQTsdocsSnap?.data().imageUrls?.[0] ??
  //             userQTsdocsSnap?.data().photoUrl ??
  //             "",
  //           createdByData: userTemp?.data() ? userTemp.data() : null,
  //           narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //         };
  //       });

  //       return Promise.all(qtPromises);
  //     });

  //     const albumsData = await Promise.all(albumPromises);
  //     const flattenedAlbumsData = albumsData.flat().filter(Boolean);

  //     // Ensure no duplicates
  //     const uniqueQTs = new Map();

  //     [...temp, ...sharedQTsData, ...flattenedAlbumsData].forEach((qt) => {
  //       if (!uniqueQTs.has(qt.id)) {
  //         uniqueQTs.set(qt.id, qt);
  //       }
  //     });

  //     const uniqueQTsArray = Array.from(uniqueQTs.values());

  //     setQuictalesInOrg(uniqueQTsArray);
  //     setAllQuickTales(uniqueQTsArray);
  //     console.log("qt::", uniqueQTsArray);

  //     return uniqueQTsArray; // Return the data if needed elsewhere
  //   } catch (error) {
  //     console.error("Error getting user albums:", error.message);
  //     throw error; // Optionally rethrow to handle it in the calling function
  //   }
  // };
  // Function to get quicktales shared with the user

  // const handleGetUserAlbums = async () => {
  //   try {
  //     const temp = [];
  //     const userId = location?.state?.albumDetails?.user;

  //     // Fetch the shared albums and user quick tales in parallel
  //     const [docsSnap, userQTsdocsSnap] = await Promise.all([
  //       getSpecificUserAlbumShares(userId),
  //       getSpecificUserQuickTales(userId),
  //     ]);

  //     // Convert QuerySnapshot to array of documents if necessary
  //     const docsArray = docsSnap.docs ? docsSnap.docs : docsSnap;

  //     // Process shared albums
  //     const albumPromises = docsArray.flatMap(async (item) => {
  //       const albumDocSnap = await getAlbumbyId(item.data().album);
  //       const qtsIdsTemp = albumDocSnap.data().quicktales;

  //       // Fetch all quick tales and related user data in parallel
  //       const qtPromises = qtsIdsTemp.map(async (qt) => {
  //         try {
  //           console.log("Fetching Quick Tale:", qt);
  //           const userQTsdocsSnap = await getSingleQuickTale(qt);
  //           console.log("Fetched Quick Tale:", userQTsdocsSnap);

  //           console.log(
  //             "Fetching User Data:",
  //             userQTsdocsSnap.data().createdBy
  //           );
  //           const [userTemp, narratorTemp] = await Promise.all([
  //             getSingleUser(userQTsdocsSnap.data().createdBy),
  //             getSingleUser(userQTsdocsSnap.data().narrator),
  //           ]);
  //           console.log("Fetched User Data:", userTemp, narratorTemp);

  //           let dataTemp = {
  //             id: userQTsdocsSnap.id,
  //             ...userQTsdocsSnap.data(),
  //             photoUrl:
  //               userQTsdocsSnap?.data().imageUrls?.[0] ??
  //               userQTsdocsSnap?.data().photoUrl ??
  //               "",
  //             createdByData: userTemp?.data() ? userTemp.data() : null,
  //             narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //           };

  //           console.log("data qts:", dataTemp);

  //           return dataTemp;
  //         } catch (error) {
  //           console.error("Error processing quick tale:", error.message);
  //           return null; // Skip the failed quick tale
  //         }
  //       });

  //       return Promise.all(qtPromises);
  //     });

  //     const albumsData = await Promise.all(albumPromises);

  //     // Flatten and filter out null values (in case of any errors)
  //     albumsData
  //       .flat()
  //       .filter(Boolean)
  //       .forEach((album) => temp.push(album));

  //     // Process user quick tales
  //     const userQTsArray = userQTsdocsSnap.docs
  //       ? userQTsdocsSnap.docs
  //       : userQTsdocsSnap;

  //     userQTsArray.forEach((item) => {
  //       temp.push({ id: item.id, ...item.data() });
  //     });

  //     setQuictalesInOrg(temp);
  //     console.log("qt::", temp);
  //     return temp; // Return the data if needed elsewhere
  //   } catch (error) {
  //     console.error("Error getting user albums:", error.message);
  //     throw error; // Optionally rethrow to handle it in the calling function
  //   }
  // };

  // const handleGetUserAlbums = async () => {
  //   try {
  //     let temp = [];
  //     const docsSnap = await getSpecificUserAlbumShares(
  //       location?.state?.albumDetails?.user
  //     );
  //     docsSnap.forEach(async (item) => {
  //       let albumDocSnap = await getAlbumbyId(item.data().album);
  //       let qtsIdsTemp = albumDocSnap.data().quicktales;
  //       qtsIdsTemp.forEach(async (qt) => {
  //         const userQTsdocsSnap = await getSingleQuickTale(qt);
  //         let userTemp = await getSingleUser(userQTsdocsSnap.data().createdBy);
  //         let narratorTemp = await getSingleUser(
  //           userQTsdocsSnap.data().narrator
  //         );
  //         temp.push({
  //           id: userQTsdocsSnap.id,
  //           ...userQTsdocsSnap.data(),
  //           photoUrl:
  //             userQTsdocsSnap?.data().imageUrls?.[0] ??
  //             userQTsdocsSnap?.data().photoUrl ??
  //             "",
  //           createdByData: userTemp?.data() ? userTemp.data() : null,
  //           narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //         });
  //       });
  //     });

  //     const userQTsdocsSnapTemp = await getSpecificUserQuickTales(
  //       location?.state?.albumDetails?.user
  //     );

  //     userQTsdocsSnapTemp.forEach(async (item) => {
  //       const userQTsdocsSnap = await getSingleQuickTale(item.id);
  //       let userTemp = await getSingleUser(userQTsdocsSnap.data().createdBy);
  //       let narratorTemp = await getSingleUser(userQTsdocsSnap.data().narrator);
  //       temp.push({
  //         id: userQTsdocsSnap.id,
  //         ...userQTsdocsSnap.data(),
  //         photoUrl:
  //           userQTsdocsSnap?.data().imageUrls?.[0] ??
  //           userQTsdocsSnap?.data().photoUrl ??
  //           "",
  //         createdByData: userTemp?.data() ? userTemp.data() : null,
  //         narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //       });
  //       // temp.push({ id: item.id, ...item.data() });
  //     });

  //     // Process shared quick tales
  //     const sharedQTsArray = await getQuicktalesSharedWithUser(
  //       location?.state?.albumDetails?.user
  //     );
  //     // const sharedQTsArray = sharedQTsdocsSnap.docs
  //     //   ? sharedQTsdocsSnap.docs
  //     //   : sharedQTsdocsSnap;

  //     sharedQTsArray.forEach(async (item) => {
  //       const quickTaleId = item.data().quicktale;
  //       const userQTsdocsSnap = await getSingleQuickTale(quickTaleId);
  //       let userTemp = await getSingleUser(userQTsdocsSnap.data().createdBy);
  //       let narratorTemp = await getSingleUser(userQTsdocsSnap.data().narrator);
  //       return {
  //         id: userQTsdocsSnap.id,
  //         ...userQTsdocsSnap.data(),
  //         photoUrl:
  //           userQTsdocsSnap?.data().imageUrls?.[0] ??
  //           userQTsdocsSnap?.data().photoUrl ??
  //           "",
  //         createdByData: userTemp?.data() ? userTemp.data() : null,
  //         narratorData: narratorTemp?.data() ? narratorTemp.data() : null,
  //       };
  //     });
  //     console.log("data::", temp)

  //     setQuictalesInOrg(temp);
  //     setAllQuickTales(temp);
  //   } catch (error) {
  //     console.log("error getting user albums:", error.message);
  //   }
  // };

  const handleSearchQuickTales = async (e) => {
    const filteredQuicktales = allQuickTales.filter(
      (quicktale) => !idsToRemove.includes(quicktale.id)
    );
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let quicktalesSearchTemp = await quickTalesSearch(
          filteredQuicktales,
          value
        );
        // console.log("quicktalesSearchTemp",quicktalesSearchTemp);
        setQuictalesInOrg(quicktalesSearchTemp);
      } else {
        setQuictalesInOrg(filteredQuicktales);
      }
    } catch (error) {
      console.log("error searching quicktales:", error.message);
    }
  };

  const handleSaveQuickTales = async () => {
    console.log("selectedID", selected);
    try {
      setLoading(true);
      const existingQuicktales = albumDetails.quicktales || [];
      const updatedQuicktales = [...selected, ...existingQuicktales];
      console.log("Merged QuickTales:", updatedQuicktales);
      let dataTemp = {
        quicktales: updatedQuicktales,
        privacy: "public",
      };
      const selectedQTs = allQuickTales
        .filter((qt) => selected.includes(qt.id))
        .map((qtData) => qtData);

      for (const qtData of selectedQTs) {
        if (qtData?.status === "private") {
          dataTemp.privacy = "private";
        }
      }

      // console.log(updateQuickTale);

      let responseTemp = await updateAlbum(albumDetails.id, dataTemp);
      setAlbumDetails((prevDetails) => ({
        ...prevDetails,
        quicktales: updatedQuicktales,
      }));

      // const sourceQuickTales = currentUser?.organization
      //   ? approvedQuickTales
      //   : organizationId
      //   ? approvedQuickTales
      //   : GAQuickTales;
      const allIdsToRemove = [...idsToRemove, ...selected];
      const filteredQuicktales = allQuickTales.filter(
        (quicktale) => !allIdsToRemove.includes(quicktale.id)
      );
      // Set the filtered quicktales to state
      setQuictalesInOrg(filteredQuicktales);
      // await handleGetAllAlbums();

      setSelected([]);
      navigate(routes.albumInOrgDetails, {
        state: { albumDetails },
      });
      showNotification("Album QuickTales added successfully.");
      // Toast("success", "Album quicktales added successfully.");
    } catch (error) {
      console.log("error updating album quicktales:", error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add QuickTales to ${albumDetails && albumDetails.title}`}
        bgColor="#fff"
        buttonText={"Edit"}
        submitButtonText={"Submit"}
        // handleGetIdQuickTales={handleGetIdQuickTales}
        selected={selected}
        setSelected={setSelected}
        editEnabled={true}
        cancelButton={true}
        loading={loading}
        onCancelClick={() => {
          navigate(routes.albumInOrgDetails, {
            state: { albumDetails },
          });
        }}
        handleSave={handleSaveQuickTales}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          <TableSearchBar
            placeholder={"Search Title, Created By, Told By"}
            handleSearch={handleSearchQuickTales}
          />

          <CommonTable
            tableData={quictalesInOrg}
            selected={selected}
            setSelected={setSelected}
            CommonTableRow={QuickTalesTableRow}
            showPosition={false}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddQuickTalesToAlbumContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
